import _ from "lodash";
import { Component } from "../components/components/component";
import { SimpleScreen } from "../controls/simpleScreen";
import { AuthProvider } from "./authProvider";
import { Route, Router } from "./router";

export interface SinglePageAppOptions {
    element: JQuery;
    view: () => Component;
    router: Router;
    routes: Route[];
}

export class SinglePageApp {

    options: SinglePageAppOptions;
    view: Component;

    constructor(options: SinglePageAppOptions) {
        this.options = options;
    }

    start(): void {
        _.forEach(this.options.routes, route => {
            this.options.router.route(route);
        });

        this.view = this.options.view();
        this.view.options.zScreen = new SimpleScreen({});
        this.view.router = this.options.router;
        this.view.render(this.options.element);

        this.options.router.start();
    }

}
